import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { usersApi } from "../../../services/api";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import DeleteIcon from "@mui/icons-material/Delete";
import { Grid } from "@mui/material";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";

type UserDetailsFooterProps = {
  onResetPassword?: () => void;
  removeResterPasswordButton?: boolean;
  isFromProfile?: boolean;
};

export function UserDetailsFooter(props: UserDetailsFooterProps) {
  const path = window.location.pathname;
  const userId = path.split("/")[2];
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [openDeleteErrorModal, setOpenDeleteErrorModal] = useState(false);
  const [openDeleteSuccessModal, setOpenDeleteSuccessModal] = useState(false);
  const { isMobile } = useContext(MainContext);
  const navigate = useNavigate();

  return (
    <>
      <Grid
        sx={{
          flexDirection: isMobile ? "column" : "row",
          display: "flex",
          alignItems: "center",
          height: "100px",
          justifyContent: "space-between",
        }}
      >
        {!props.removeResterPasswordButton && (
          <PrimaryBaseButton
            startIcon={<RestartAltIcon />}
            title="Resetar Senha"
            onClick={props.onResetPassword}
          />
        )}
        <DangerBaseButton
          startIcon={<DeleteIcon />}
          title={props.isFromProfile ? "Deletar" : "Deletar Usuário"}
          onClick={() => setShowDeleteModal(true)}
        />
      </Grid>
      <ConfirmationModal
        contentText={
          props.isFromProfile
            ? "Deseja confirmar a exclusão?"
            : "Deseja confirmar a exclusão do usuário?"
        }
        title={props.isFromProfile ? "Excluir" : "Excluir Usuário"}
        open={showDeleteModal}
        setOpen={setShowDeleteModal}
        onConfirm={async () => {
          await usersApi.deleteUser(userId);
        }}
        setOpenErrorModal={setOpenDeleteErrorModal}
        setOpenSuccessModal={setOpenDeleteSuccessModal}
        confirmationButtonColor="error"
      />

      <ActionAlert
        severity="success"
        open={openDeleteSuccessModal}
        setOpen={setOpenDeleteSuccessModal}
        // title={
        //   props.isFromProfile
        //     ? "Perfil deletado com sucesso"
        //     : "Usuário deletado com Sucesso!"
        // }
        message={
          props.isFromProfile
            ? "O perfil foi deletado com sucesso"
            : "O usuário foi deletado com sucesso!"
        }
        onClose={() => {
          setShowDeleteModal(false);
          navigate("/users");
        }}
      />
      <ActionAlert
        severity="error"
        open={openDeleteErrorModal}
        setOpen={setOpenDeleteErrorModal}
        // title={
        //   props.isFromProfile ? "Erro ao deletar" : "Erro ao deletar o Usuário"
        // }
        message={
          props.isFromProfile
            ? "Ocorreu um erro ao deletar!"
            : "Ocorreu um erro ao deletar o usuário!"
        }
        onClose={() => {
          setShowDeleteModal(false);
        }}
      />
    </>
  );
}
